/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  PaginatedTimeBlockList,
  PatchedTimeBlockRequest,
  TimeBlock,
  TimeBlockRequest,
  TimeBlocksListParams
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getTimeBlocksListUrl = (params?: TimeBlocksListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/time-blocks/?${stringifiedParams}` : `/api/time-blocks/`
}

/**
 * A time-block represents a colloquial period of time such as morning, afternoon, or night
 * This API is designed for gigpro admins to allow CRU of time-blocks.
 * start_time and end_time are local time fields (ex: 15:00:00).
 * They are local so that one morning time-block like 3am to 11am, for example, can be used across any market.
 */
export const timeBlocksList = async (params?: TimeBlocksListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedTimeBlockList> => {

  return customFetch<PaginatedTimeBlockList>(getTimeBlocksListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTimeBlocksListInfiniteQueryKey = (params?: TimeBlocksListParams,) => {
    return [
    'infinite', `/api/time-blocks/`, ...(params ? [params] : [])
    ] as const;
    }

export const getTimeBlocksListQueryKey = (params?: TimeBlocksListParams,) => {
    return [
    `/api/time-blocks/`, ...(params ? [params] : [])
    ] as const;
    }


export const getTimeBlocksListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof timeBlocksList>>, TimeBlocksListParams['page']>, TError = void>(params?: TimeBlocksListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof timeBlocksList>>, TError, TData, QueryKey, TimeBlocksListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTimeBlocksListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof timeBlocksList>>, QueryKey, TimeBlocksListParams['page']> = ({ signal, pageParam }) => timeBlocksList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof timeBlocksList>>, TError, TData, QueryKey, TimeBlocksListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TimeBlocksListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof timeBlocksList>>>
export type TimeBlocksListInfiniteQueryError = void


export function useTimeBlocksListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof timeBlocksList>>, TimeBlocksListParams['page']>, TError = void>(
 params: undefined |  TimeBlocksListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof timeBlocksList>>, TError, TData, QueryKey, TimeBlocksListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof timeBlocksList>>,
          TError,
          Awaited<ReturnType<typeof timeBlocksList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimeBlocksListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof timeBlocksList>>, TimeBlocksListParams['page']>, TError = void>(
 params?: TimeBlocksListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof timeBlocksList>>, TError, TData, QueryKey, TimeBlocksListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof timeBlocksList>>,
          TError,
          Awaited<ReturnType<typeof timeBlocksList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimeBlocksListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof timeBlocksList>>, TimeBlocksListParams['page']>, TError = void>(
 params?: TimeBlocksListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof timeBlocksList>>, TError, TData, QueryKey, TimeBlocksListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTimeBlocksListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof timeBlocksList>>, TimeBlocksListParams['page']>, TError = void>(
 params?: TimeBlocksListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof timeBlocksList>>, TError, TData, QueryKey, TimeBlocksListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTimeBlocksListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTimeBlocksListQueryOptions = <TData = Awaited<ReturnType<typeof timeBlocksList>>, TError = void>(params?: TimeBlocksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timeBlocksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTimeBlocksListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof timeBlocksList>>> = ({ signal }) => timeBlocksList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof timeBlocksList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TimeBlocksListQueryResult = NonNullable<Awaited<ReturnType<typeof timeBlocksList>>>
export type TimeBlocksListQueryError = void


export function useTimeBlocksList<TData = Awaited<ReturnType<typeof timeBlocksList>>, TError = void>(
 params: undefined |  TimeBlocksListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof timeBlocksList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof timeBlocksList>>,
          TError,
          Awaited<ReturnType<typeof timeBlocksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimeBlocksList<TData = Awaited<ReturnType<typeof timeBlocksList>>, TError = void>(
 params?: TimeBlocksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timeBlocksList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof timeBlocksList>>,
          TError,
          Awaited<ReturnType<typeof timeBlocksList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimeBlocksList<TData = Awaited<ReturnType<typeof timeBlocksList>>, TError = void>(
 params?: TimeBlocksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timeBlocksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTimeBlocksList<TData = Awaited<ReturnType<typeof timeBlocksList>>, TError = void>(
 params?: TimeBlocksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timeBlocksList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTimeBlocksListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTimeBlocksCreateUrl = () => {




  return `/api/time-blocks/`
}

/**
 * A time-block represents a colloquial period of time such as morning, afternoon, or night
 * This API is designed for gigpro admins to allow CRU of time-blocks.
 * start_time and end_time are local time fields (ex: 15:00:00).
 * They are local so that one morning time-block like 3am to 11am, for example, can be used across any market.
 */
export const timeBlocksCreate = async (timeBlockRequest: TimeBlockRequest, options?: Parameters<typeof customFetch>[1]): Promise<TimeBlock> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<TimeBlock>(getTimeBlocksCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(timeBlockRequest)
  }
);}





export const getTimeBlocksCreateMutationKey = () => ['timeBlocksCreate'] as const;

export const getTimeBlocksCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timeBlocksCreate>>, TError,TimeBlocksCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof timeBlocksCreate>>, TError,TimeBlocksCreateMutationVariables, TContext> => {

const mutationKey = getTimeBlocksCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof timeBlocksCreate>>, TimeBlocksCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  timeBlocksCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TimeBlocksCreateMutationResult = NonNullable<Awaited<ReturnType<typeof timeBlocksCreate>>>
    export type TimeBlocksCreateMutationBody = TimeBlockRequest
    export type TimeBlocksCreateMutationError = void
    export type TimeBlocksCreateMutationVariables = {data: TimeBlockRequest}

    export const useTimeBlocksCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timeBlocksCreate>>, TError,TimeBlocksCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof timeBlocksCreate>>,
        TError,
        TimeBlocksCreateMutationVariables,
        TContext
      > => {
      return useMutation(getTimeBlocksCreateMutationOptions(options), queryClient);
    }
    export const getTimeBlocksRetrieveUrl = (id: number,) => {




  return `/api/time-blocks/${id}/`
}

/**
 * A time-block represents a colloquial period of time such as morning, afternoon, or night
 * This API is designed for gigpro admins to allow CRU of time-blocks.
 * start_time and end_time are local time fields (ex: 15:00:00).
 * They are local so that one morning time-block like 3am to 11am, for example, can be used across any market.
 */
export const timeBlocksRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<TimeBlock> => {

  return customFetch<TimeBlock>(getTimeBlocksRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTimeBlocksRetrieveQueryKey = (id: number,) => {
    return [
    `/api/time-blocks/${id}/`
    ] as const;
    }


export const getTimeBlocksRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof timeBlocksRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timeBlocksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTimeBlocksRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof timeBlocksRetrieve>>> = ({ signal }) => timeBlocksRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof timeBlocksRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TimeBlocksRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof timeBlocksRetrieve>>>
export type TimeBlocksRetrieveQueryError = void


export function useTimeBlocksRetrieve<TData = Awaited<ReturnType<typeof timeBlocksRetrieve>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof timeBlocksRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof timeBlocksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof timeBlocksRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimeBlocksRetrieve<TData = Awaited<ReturnType<typeof timeBlocksRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timeBlocksRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof timeBlocksRetrieve>>,
          TError,
          Awaited<ReturnType<typeof timeBlocksRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTimeBlocksRetrieve<TData = Awaited<ReturnType<typeof timeBlocksRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timeBlocksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTimeBlocksRetrieve<TData = Awaited<ReturnType<typeof timeBlocksRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof timeBlocksRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTimeBlocksRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTimeBlocksUpdateUrl = (id: number,) => {




  return `/api/time-blocks/${id}/`
}

/**
 * A time-block represents a colloquial period of time such as morning, afternoon, or night
 * This API is designed for gigpro admins to allow CRU of time-blocks.
 * start_time and end_time are local time fields (ex: 15:00:00).
 * They are local so that one morning time-block like 3am to 11am, for example, can be used across any market.
 */
export const timeBlocksUpdate = async (id: number,
    timeBlockRequest: TimeBlockRequest, options?: Parameters<typeof customFetch>[1]): Promise<TimeBlock> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<TimeBlock>(getTimeBlocksUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(timeBlockRequest)
  }
);}





export const getTimeBlocksUpdateMutationKey = () => ['timeBlocksUpdate'] as const;

export const getTimeBlocksUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timeBlocksUpdate>>, TError,TimeBlocksUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof timeBlocksUpdate>>, TError,TimeBlocksUpdateMutationVariables, TContext> => {

const mutationKey = getTimeBlocksUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof timeBlocksUpdate>>, TimeBlocksUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  timeBlocksUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TimeBlocksUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof timeBlocksUpdate>>>
    export type TimeBlocksUpdateMutationBody = TimeBlockRequest
    export type TimeBlocksUpdateMutationError = void
    export type TimeBlocksUpdateMutationVariables = {id: number;data: TimeBlockRequest}

    export const useTimeBlocksUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timeBlocksUpdate>>, TError,TimeBlocksUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof timeBlocksUpdate>>,
        TError,
        TimeBlocksUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getTimeBlocksUpdateMutationOptions(options), queryClient);
    }
    export const getTimeBlocksPartialUpdateUrl = (id: number,) => {




  return `/api/time-blocks/${id}/`
}

/**
 * A time-block represents a colloquial period of time such as morning, afternoon, or night
 * This API is designed for gigpro admins to allow CRU of time-blocks.
 * start_time and end_time are local time fields (ex: 15:00:00).
 * They are local so that one morning time-block like 3am to 11am, for example, can be used across any market.
 */
export const timeBlocksPartialUpdate = async (id: number,
    patchedTimeBlockRequest?: PatchedTimeBlockRequest, options?: Parameters<typeof customFetch>[1]): Promise<TimeBlock> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<TimeBlock>(getTimeBlocksPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedTimeBlockRequest)
  }
);}





export const getTimeBlocksPartialUpdateMutationKey = () => ['timeBlocksPartialUpdate'] as const;

export const getTimeBlocksPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timeBlocksPartialUpdate>>, TError,TimeBlocksPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof timeBlocksPartialUpdate>>, TError,TimeBlocksPartialUpdateMutationVariables, TContext> => {

const mutationKey = getTimeBlocksPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof timeBlocksPartialUpdate>>, TimeBlocksPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  timeBlocksPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TimeBlocksPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof timeBlocksPartialUpdate>>>
    export type TimeBlocksPartialUpdateMutationBody = PatchedTimeBlockRequest | undefined
    export type TimeBlocksPartialUpdateMutationError = void
    export type TimeBlocksPartialUpdateMutationVariables = {id: number;data?: PatchedTimeBlockRequest}

    export const useTimeBlocksPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof timeBlocksPartialUpdate>>, TError,TimeBlocksPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof timeBlocksPartialUpdate>>,
        TError,
        TimeBlocksPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getTimeBlocksPartialUpdateMutationOptions(options), queryClient);
    }
